import React from 'react';

const HIGHLIGHTS = ['ISO 45001 compliance, built in', 'Cross-validated signal sensing', 'Enterprise-grade security & geo-fencing'];

export default function LoginBrandPane({ tagline }) {
  return (
    <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden bg-slate-900">
      <img
        src="https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400"
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-30"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-900/85 to-slate-900/60" />
      <div className="relative z-10 flex flex-col justify-between p-12 xl:p-16 text-white w-full">
        <div className="flex items-center gap-3">
          <img src="/safer-i-logo.png" alt="SAFER-i" className="w-11 h-11 object-contain rounded-xl" />
          <span className="text-xl font-bold tracking-tight">SAFER-i™</span>
        </div>
        <div className="max-w-md">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-indigo-400 mb-4">Operational Discipline</p>
          <h1 className="text-4xl xl:text-5xl font-bold leading-tight tracking-tight">
            Leadership Governance Intelligence Platform
          </h1>
          <p className="mt-5 text-base text-slate-300 leading-relaxed">{tagline}</p>
        </div>
        <ul className="space-y-3 text-sm text-slate-300">
          {HIGHLIGHTS.map((t) => (
            <li key={t} className="flex items-center gap-3">
              <span className="w-1.5 h-1.5 rounded-full bg-indigo-400 flex-shrink-0" />
              {t}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
